import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SubscriptionsService } from 'app/infrastructure/services/subscriptions.service';
import { Observable } from 'rxjs';
import { ItemGeneralListado } from 'app/helpers/components/itemClasses/itemListadoGeneral.class';

@Component({
  templateUrl: './configurar.opciones.component.html'
})
export class ConfigurarOpcionesComponent implements OnInit {
  itemOver: string;
  codOrganization: string;
  codSubscription: string;
  comandos: Observable<ItemGeneralListado[]>;
  
  constructor(private aRoute: ActivatedRoute,
              private router: Router,
              private srvSubscription: SubscriptionsService) 
              { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSubscription = params['codsistema'];
      this.codOrganization = params['codorganizacion'];
      this.comandos =this.srvSubscription.getOptions(this.codOrganization,this.codSubscription);

    });
  }

  volver() {
    this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/opciones/configurar.opciones.component.ts